'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'SupportToolRestService',
    function ($modal, SupportToolRestService) {

        return {
            edit: edit,
            create: create,
            api: SupportToolRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/support-tool-modal-create.html'),
                controller: 'SupportToolModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    supportTool: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/support-tool-modal-create.html'),
                controller: 'SupportToolModalCreateController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: false,
                resolve: {
                    supportTool: function () {
                        return item;
                    }
                }
            });
        }

    }];